import { z } from 'zod';
import { BillingRegion, PaymentProvider } from './types';

/**
 * 상품 조회 응답에 서버가 내려주는 billing region/provider 필드.
 * 구버전 캐시 응답 대비 optional 로 두고, 소비 측에서 fallback(KR/Toss)을 적용한다.
 *
 * 금액은 상품 본문의 `currency` + `customerAmount`/`originAmount` 가 전부다.
 * 서버가 요청 리전의 통화 하나만 내려주므로 표시용 별도 필드가 없다.
 */
export const productBillingSchema = z.object({
  billingRegion: z.nativeEnum(BillingRegion).optional(),
  paymentProvider: z.nativeEnum(PaymentProvider).optional(),
});
